import { WebPlayQuestionFileUploadStorageService } from './WebPlayQuestionFileUploadStorageService'

export class FileUploadServiceProvider {
  constructor(playbookId) {
    this.playbookId = playbookId
  }

  getService(question) {
    return new FileUploadService(this.playbookId, question)
  }
}

class FileUploadService {
  get isDisabled() {
    return !this.playbookId
  }

  constructor(playbookId, question) {
    this.playbookId = playbookId
    this.question = question
    this.storageService = new WebPlayQuestionFileUploadStorageService(this.playbookId)
  }

  async deleteFile(fileItem) {
    await this.storageService.deleteFile(fileItem)
  }

  async uploadFiles(uploadingFiles, currentHeader) {
    const newFileItems = []
    for (let i = 0; i < uploadingFiles.length; i++) {
      const file = uploadingFiles[i]
      try {
        if (file.size > 30 * 1024 * 1024) {
          throw new Error('File size exceeds the limit of 30MB')
        }
        await this.storageService.saveFile(this.question, currentHeader, file).then(id => {
          newFileItems.push({ id: id, name: file.name })
        })
      } catch (error) {
        newFileItems.push({ id: 0, name: file.name, error: error.message })
      }
    }
    return newFileItems
  }
}
